import Header from "../components/components-home/header/Header";
import Footer from "../components/components-home/Footer";
import Social from "../components/components-home/Social";
import "./../assets/style/index.css";

/**
 * Marco para las páginas públicas (vitrina y perfil de modelo): mismo header y
 * footer del sitio, sin sidebar ni requisitos de sesión.
 */
export default function PublicLayout({ children }) {
    return (
        <div className="public-shell">
            <Header />
            <main className="public-main">{children}</main>
            <Footer />
            <Social />
        </div>
    );
}
